import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { getAll } from '../api/ventura/location';
import { useConfig } from './useConfig';

function useAdGroupLocations(
  adGroupId: number,
  excluded: boolean = false,
  term: string = '',
  defaultPerPage: number = 10
) {
  const { apiHost } = useConfig();
  const [page, setPage] = React.useState<number>(0);
  const [perPage, setPerPage] = React.useState<number>(defaultPerPage);
  const query = useQuery({
    queryKey: ['adGroupLocations', adGroupId, excluded, page, perPage, term],
    queryFn: () => getAll(apiHost, adGroupId, excluded, term, { page, perPage }),
    enabled: !!adGroupId,
  });

  return { page, setPage, perPage, setPerPage, ...query };
}

export default useAdGroupLocations;
